import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=c4bea064&scoped=true"
import script from "./ChangePass.vue?vue&type=script&lang=js"
export * from "./ChangePass.vue?vue&type=script&lang=js"
import style0 from "./ChangePass.vue?vue&type=style&index=0&id=c4bea064&prod&lang=postcss"
import style1 from "./ChangePass.vue?vue&type=style&index=1&id=c4bea064&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bea064",
  null
  
)

export default component.exports